import { Box, Flex, Line } from 'components';
import { BackButton } from 'components/BackButton';
import { H1 } from 'components/Typography/Typography';
import { Wrapper } from './AreasAndOrganizationStructureView.styled';
import { t } from 'i18next';
import { Button } from 'components/_form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { AreaAccordion } from './components/AreaAccordion';
import { useMemo, useState } from 'react';
import { AddAreaModal } from './components/AddAreaModal';
import { AreaDetailsForm } from './components/AreaDetailsForm';
import { useAreasQuery } from 'hooks/queries/useAreasQuery';
import { parentToChildrenAreasStructure } from 'utilities/areas';
import { AreaAccordionItem, IArea } from 'types/area';

export const AreasAndOrganizationStructureView = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditFormOpen, setIsEditFormOpen] = useState(false);
  const [selectedArea, setSelectedArea] = useState<AreaAccordionItem | undefined>();
  const [parentArea, setParentArea] = useState<Pick<IArea, 'id' | 'name'> | undefined>();

  const { data: areasData = [] } = useAreasQuery();
  const areas = useMemo<AreaAccordionItem[]>(
    () => parentToChildrenAreasStructure(areasData),
    [areasData]
  );

  const openAddRootModal = () => {
    setParentArea(undefined);
    setIsModalOpen(true);
  };

  const openAddSubModal = (item: AreaAccordionItem) => {
    setParentArea({ id: item.id, name: item.name });
    setIsModalOpen(true);
  };

  const renderAccordion = (item: AreaAccordionItem) => (
    <AreaAccordion
      key={item.id}
      title={item.name}
      active={String(item.state).toLowerCase() === 'active'}
      onAddClick={() => openAddSubModal(item)}
      onEditClick={() => {
        setIsEditFormOpen(true);
        setSelectedArea(item);
      }}
    >
      {item.children?.length && item.children.map((child) => renderAccordion(child))}
    </AreaAccordion>
  );

  return (
    <>
      <Wrapper>
        <Flex width="100%">
          <BackButton
            customOnClick={
              isEditFormOpen ? () => setIsEditFormOpen(false) : undefined
            }
          />
          <H1 m={2} variant={['h3', 'h2']} textTransform="uppercase">
            {t('administration.administrationLabel')} -{' '}
            {t('administration.STRUCTURE OF AREAS')}
            {isEditFormOpen && selectedArea && `: ${selectedArea.name}`}
          </H1>
        </Flex>
        <Line />

        {isEditFormOpen && selectedArea ? (
          <AreaDetailsForm
            data={selectedArea}
            onCancel={() => setIsEditFormOpen(false)}
          />
        ) : (
          <>
            <Flex mb={3}>
              <Button variant="eucalyptus" onClick={openAddRootModal}>
                <Flex>
                  <Box mr={2}>
                    <FontAwesomeIcon icon={faCirclePlus} />
                  </Box>
                  {t('administration.add')}
                </Flex>
              </Button>
            </Flex>

            {areas.map((item) => renderAccordion(item))}
          </>
        )}
      </Wrapper>

      <AddAreaModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        parentArea={parentArea}
      />
    </>
  );
};
